//@ts-nocheck
export const  timeConvert = (n) => {
    let number = n;
    let hours = (number / 60);
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
   
    return number = rhours + "h " + rminutes + "m";
}